// ⚠️ Do not use environment for by environment specific configuration use ConfigService instead.

export const environment = {
  production: true,
};
